export default "__VITE_ASSET__DYkxzNfl__"